import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/features/auth/auth.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Configurações da conta autenticada, cacheadas por aba.
 * Existe um único tipo de conta (MGA); o que varia entre contas é a integração OON.
 */
@Injectable({
    providedIn: 'root'
})
export class AccountTypeService {

    constructor(private authService: AuthService) { }

    /**
     * Informa se a conta possui a integração OON habilitada (do cache ou do banco)
     */
    getOonIntegrationEnabled(): Observable<boolean> {
        if (this.hasCachedOonIntegration()) {
            return of(this.isOonIntegrationEnabled());
        }

        return new Observable<boolean>(observer => {
            this.authService.getAccountType().subscribe({
                next: (response) => {
                    const enabled = !!response.oon_integration_enabled;
                    this.setCachedOonIntegrationEnabled(enabled);
                    observer.next(enabled);
                    observer.complete();
                },
                error: (error) => {
                    console.error('Erro ao buscar configurações da conta:', error);
                    this.setCachedOonIntegrationEnabled(false);
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }

    /**
     * Grava nesta aba se a conta possui a integração OON habilitada
     */
    setCachedOonIntegrationEnabled(enabled: boolean): void {
        sessionStorage.setItem('oon_integration_enabled', enabled ? '1' : '0')
    }

    /**
     * Verifica se a conta possui a integração OON habilitada (síncrono)
     */
    isOonIntegrationEnabled(): boolean {
        return sessionStorage.getItem('oon_integration_enabled') === '1';
    }

    private hasCachedOonIntegration(): boolean {
        const cached = sessionStorage.getItem('oon_integration_enabled');
        return cached === '1' || cached === '0';
    }

    /**
     * Limpa o cache (usar no logout)
     */
    clearCache(): void {
        sessionStorage.removeItem('oon_integration_enabled');
    }
}
